import * as types from './mutation-types';

export default {
  [types.SET_CREDIT_LIMIT](state) {
    state.creditLimit = !state.creditLimit;
  },
};
